import { ToppingsEnum, TOPPING_IMAGES, ToppingStatus } from './toppings_defs';

import './toppings-section.css';

interface ToppingsSectionProps {
    addTopping: (topping: string) => void;
    status: { [topping in ToppingsEnum]?: ToppingStatus };
}

function ToppingsSection(props: ToppingsSectionProps) {
    const { addTopping, status } = props;

    return (
        <div className="toppings-section">
            <div className="toppings-title">Toppings</div>
            <div className="toppings-display">
                {Object.values(ToppingsEnum).map((topping) => {
                    let backgroundColor = 'lightcyan';
                    if (topping in status) {
                        if (status[topping] === ToppingStatus.GRAY) {
                            backgroundColor = 'gray';
                        } else if (status[topping] === ToppingStatus.GREEN) {
                            backgroundColor = 'green';
                        } else if (status[topping] === ToppingStatus.YELLOW) {
                            backgroundColor = 'yellow';
                        }
                    }
                    return (
                        <div
                            key={topping}
                            className="topping"
                            onClick={() => addTopping(topping[0])}
                            style={{
                                backgroundColor,
                            }}
                        >
                            <img
                                src={TOPPING_IMAGES[topping]}
                                alt={topping}
                                className="topping-image"
                            />
                            {`(${topping[0]})${topping.slice(1)}`}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ToppingsSection;
